import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { altPath, langFromPath } from '@/i18n/routes';

const SITE_URL = 'https://www.perpetualplexus.nl';

interface SeoProps {
  title: string;
  description: string;
  /** Path of this page; defaults to the current location. */
  path?: string;
  noindex?: boolean;
}

export function Seo({ title, description, path, noindex }: SeoProps) {
  const location = useLocation();
  const current = path ?? location.pathname;
  const url = `${SITE_URL}${current}`;
  const lang = langFromPath(current);
  const alt = altPath(current);

  return (
    <Helmet>
      <html lang={lang} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <link rel="alternate" hrefLang={lang} href={url} />
      {alt && <link rel="alternate" hrefLang={alt.lang} href={`${SITE_URL}${alt.path}`} />}
      {alt && <link rel="alternate" hrefLang="x-default" href={`${SITE_URL}${lang === 'nl' ? current : alt.path}`} />}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content={lang === 'nl' ? 'nl_NL' : 'en_US'} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
    </Helmet>
  );
}
